var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Upload-Check"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Upload-Check",
    clipPath: "url(#clip-Upload-Check)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "check-circle-solid",
    d: "M33,20.5A12.5,12.5,0,1,1,20.5,8,12.5,12.5,0,0,1,33,20.5ZM19.054,27.119l9.274-9.274a.806.806,0,0,0,0-1.14l-1.14-1.14a.806.806,0,0,0-1.141,0l-7.563,7.563L14.953,19.6a.807.807,0,0,0-1.141,0l-1.14,1.14a.806.806,0,0,0,0,1.14l5.242,5.242a.806.806,0,0,0,1.141,0Z",
    transform: "translate(-8 -8)",
    fill: "#0085ff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDone);
export default __webpack_public_path__ + "static/media/done.fa3c4490.svg";
export { ForwardRef as ReactComponent };